var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCleverSso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.328 29.333C5.672 29.333 0 23.476 0 16.073v-.065C0 8.67 5.574 2.667 13.557 2.667c4.902 0 7.836 1.627 10.246 3.986l-3.64 4.133c-2-1.807-4.048-2.913-6.638-2.913-4.377 0-7.541 3.612-7.541 8.038v.08c0 4.426 3.082 8.103 7.54 8.103 2.968 0 4.787-1.171 6.837-3.026L24 24.713c-2.689 2.847-5.656 4.62-10.672 4.62z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36 0h1.333v32H36V0z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 38 32'%3E%3Cpath d='M13.328 29.333C5.672 29.333 0 23.476 0 16.073v-.065C0 8.67 5.574 2.667 13.557 2.667c4.902 0 7.836 1.627 10.246 3.986l-3.64 4.133c-2-1.807-4.048-2.913-6.638-2.913-4.377 0-7.541 3.612-7.541 8.038v.08c0 4.426 3.082 8.103 7.54 8.103 2.968 0 4.787-1.171 6.837-3.026L24 24.713c-2.689 2.847-5.656 4.62-10.672 4.62z' fill='%23fff'/%3E%3Cpath opacity='.5' d='M36 0h1.333v32H36V0z' fill='%23fff'/%3E%3C/svg%3E";
export { SvgCleverSso as ReactComponent };